<template>
  <v-container class="text-center pt-5" justify="center" align="center">
    <!-- logo -->
    <v-row>
      <v-col>
        <img alt="Logo" src="../assets/img/logo.png" width="200" height="200"/>
      </v-col>
    </v-row>

    <!-- titulo -->
    <!-- <v-row>
      <v-col>
        <h1 class="text-h2">Sistema</h1>
      </v-col>
    </v-row>
 -->
    <!-- descripcion -->
    <!-- <v-row>
      <v-col>
        <h2
          class="text-subtitle-1"
        >Sistema gestion </h2>
      </v-col>
    </v-row> -->

    <!-- ejemplos botones / numericas -->
    <v-row>
      <v-col v-for="item in cards" cols="12" sm="6" md="3" :key="item">
        <v-card color="primary" dark>
          <v-card-title class="headline mb-3">{{item.titulo}}</v-card-title>
          <v-card-subtitle
            class="text-left"
          >{{item.descripcion}}</v-card-subtitle>
          <v-card-actions>
            <v-btn text :to="{ path: '/disponibilidad' }">Acceder</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col></v-col>
      <v-col></v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      cards:[{
        titulo:"Disponibilidad",
        descripcion:"Permite configurar los días, modalidades y horarios disponibles para realizar las comisiones."
      }]
    }
  },
  components: {},
};
</script>
